import ResolveError from "./ResolveError.mjs";
/**
 * @public
 */
class MaximumResolveDepthError extends ResolveError {}
export default MaximumResolveDepthError;